export default Object.freeze({
  TREATMENT: 'TREATMENT',
  FILE: 'FILE',
  ORDER: 'ORDER',
  IMPRINT: 'IMPRINT',
});
